/*
  WhatsApp cart share runtime.
  Loaded once from layout/theme.liquid. Handles every button on the page through
  document-level delegation, including buttons injected later by the Section
  Rendering API (cart drawer, cart items, sticky bars).
*/
(function () {
  if (window.__waShareCart) return;
  window.__waShareCart = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MAX_LEN = 1800; // conservative ceiling for the wa.me text parameter

  function config(button) {
    return {
      phone: button.dataset.waPhone || '',
      message: button.dataset.waMessage || '[link]',
      lineItem: button.dataset.waLineItem || '- [quantity] x [title]',
      error: button.dataset.waErrorText || '',
      locale: button.dataset.waLocale || document.documentElement.lang || 'en',
      hideWhenEmpty: button.dataset.waHideWhenEmpty !== 'false'
    };
  }

  function getCart() {
    return fetch(ROOT + 'cart.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
      credentials: 'same-origin'
    }).then(function (r) {
      if (!r.ok) throw new Error('cart_fetch_failed');
      return r.json();
    });
  }

  function permalink(cart) {
    var pairs = [];
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (!item.variant_id || item.quantity < 1) continue;
      pairs.push(item.variant_id + ':' + item.quantity);
    }
    if (!pairs.length) return null;

    var url = window.location.origin + ROOT + 'cart/' + pairs.join(',') + '?storefront=true';
    var apps = cart.cart_level_discount_applications || [];
    for (var j = 0; j < apps.length; j++) {
      if (apps[j].type === 'discount_code' && apps[j].title) {
        url += '&discount=' + encodeURIComponent(apps[j].title);
        break;
      }
    }
    return url;
  }

  function money(cents, currency, locale) {
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function lines(cart, template) {
    return cart.items.map(function (item) {
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? ' (' + item.variant_title + ')'
        : '';
      return template
        .split('[quantity]').join(item.quantity)
        .split('[title]').join(item.product_title + variant);
    }).join('\n');
  }

  function compose(cfg, cart, link, includeItems) {
    return cfg.message
      .split('[items]').join(includeItems ? lines(cart, cfg.lineItem) : '')
      .split('[count]').join(cart.item_count)
      .split('[total]').join(money(cart.total_price, cart.currency, cfg.locale))
      .split('[link]').join(link);
  }

  function tagCart() {
    fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: { 'Shared to support': 'WhatsApp' } })
    }).catch(function () {});
  }

  function setError(button, text) {
    var label = button.querySelector('.wa-share-cart__label');
    button.setAttribute('data-wa-error', '');
    if (!label || !text) return;
    if (!button.dataset.waOriginalLabel) button.dataset.waOriginalLabel = label.textContent;
    label.textContent = text;
    setTimeout(function () {
      label.textContent = button.dataset.waOriginalLabel;
      button.removeAttribute('data-wa-error');
    }, 4000);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wa-share-cart]');
    if (!button) return;
    event.preventDefault();

    var cfg = config(button);
    if (!cfg.phone) return;

    // Opened synchronously: iOS Safari blocks window.open once a promise has resolved.
    var tab = window.open('', '_blank');
    button.setAttribute('aria-busy', 'true');

    getCart()
      .then(function (cart) {
        var link = permalink(cart);
        if (!link) throw new Error('cart_empty');

        var text = compose(cfg, cart, link, true);
        if (encodeURIComponent(text).length > MAX_LEN) text = compose(cfg, cart, link, false);

        tagCart();
        var target = 'https://wa.me/' + cfg.phone + '?text=' + encodeURIComponent(text);
        if (tab && !tab.closed) { tab.location.href = target; } else { window.location.href = target; }
      })
      .catch(function () {
        if (tab && !tab.closed) tab.close();
        setError(button, cfg.error);
      })
      .finally(function () {
        button.removeAttribute('aria-busy');
      });
  });

  // Keeps buttons placed outside the cart template in sync with cart mutations.
  // Themes emit no standard cart event, so Ajax cart writes are observed.
  var nativeFetch = window.fetch;
  window.fetch = function () {
    var request = arguments[0];
    var url = typeof request === 'string' ? request : (request && request.url) || '';
    return nativeFetch.apply(this, arguments).then(function (response) {
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        document.dispatchEvent(new CustomEvent('wa:cart-updated'));
      }
      return response;
    });
  };

  function syncVisibility() {
    var buttons = document.querySelectorAll('[data-wa-share-cart]');
    if (!buttons.length) return;
    getCart().then(function (cart) {
      Array.prototype.forEach.call(buttons, function (button) {
        if (button.dataset.waHideWhenEmpty === 'false') return;
        button.hidden = cart.item_count === 0;
      });
    }).catch(function () {});
  }

  document.addEventListener('wa:cart-updated', syncVisibility);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncVisibility);
  } else {
    syncVisibility();
  }
})();